<template>
  <div v-if="dialogVisible" class="oa-wrap">
    <el-dialog title="绑定分类" :visible.sync="dialogVisible" width="70%">
      <div class="cc-w">
        <div class="content-wrap">
          <LoadingNoDialog :loading="loading">
            <el-table
              ref="multipleTable"
              @selection-change="selectionChange"
              class="clear-fix"
              border
              :empty-text="emptyText"
              :data="tableData"
              style="width: 100%"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column type="index" width="50"> </el-table-column>
              <el-table-column label="名称" prop="name"> </el-table-column>

              <el-table-column prop="payCode" label="图片">
                <template slot-scope="scope">
                  <img :src="scope.row.img" style="height: 140px" />
                </template>
              </el-table-column>

              <el-table-column prop="createdAt" label="创建时间">
              </el-table-column>
            </el-table>

            <!-- <div style="margin-top: 10px; text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[size, size*2, size*3, , 500, 1000]"
            :page-size="13"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div> -->
          </LoadingNoDialog>
        </div>
        <div class="oa-footer">
          <el-button
            type="primary"
            @click="handleSureSelect"
            :loading="subLoading"
            >确 定</el-button
          >
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer oa-footer">
        <el-button
          type="primary"
          @click="handleSureSelect"
          :loading="subLoading"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../../components/LoadingNoDialog.vue";
export default {
  name: "Role",
  props: {
    type: {
      type: Number,
      default: 2,
    },
    listType: {
      type: Number,
      default: 2,
    },
    isHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emptyText: "暂无数据",
      size: 200,
      page: 1,
      tableData: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      tagInfo: {
        objectKey: "",
        imgUrl: "",
      },
      subLoading: false,
      selectRows: [],
      initSelectRowDatas: [],

      myId: 0,
    };
  },
  components: {
    LoadingNoDialog,
  },
  mounted() {},
  methods: {
    selectionChange(rows) {
      this.selectRows = rows;
    },
    setMyRow(row) {
      this.dialogVisible = true;
      this.myId = row.id;

      if (typeof row.tTags !== "undefined") {
        this.initSelectRowDatas = row.tTags;
      } else {
        this.initSelectRowDatas = row;
      }
      this.getList();
    },
    async handleSureSelect() {
      this.subLoading = true;
     
        let r=null
    
      if (this.type < 0) {
       let postUrl = "/admin/one-to-main-tag";
         r = await axios.post(postUrl, {
          tagType: this.type,
          ids: this.selectRows.map((item) => item.id),
        });
      }else{
         let postUrl = "/admin/two-to-one-tag";
       r = await axios.post(postUrl, {
        oId: this.myId,
        tIds: this.selectRows.map((item) => item.id),
      });
      }

      this.subLoading = false;
      this.dialogVisible = false;
      if (r.code == 0) {
        this.$message({
          type: "success",
          message: "分配成功",
        });

        this.$emit("success");
      } else {
        this.$message({
          type: "success",
          message: "分配失败",
        });
      }
    },

    async getList() {
      this.loading = true;
      let r = await axios.get("/admin/two-tag-lists", {
        params: { page: this.page, size: this.size, type: this.listType },
      });
      if (r.code == 51) {
        this.loading = false;
        this.emptyText = "无权限";
        return;
      }
      this.total = r.data.count;

      this.tableData = r.data.rows.map((item) =>
        Object.assign(item, {
          createdAt: moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        })
      );
      this.$nextTick(() => {
        this.selectRows = this.tableData.filter((item) =>
          this.initSelectRowDatas.map((e) => e.id).includes(item.id)
        );
        this.loading = false;
        this.$nextTick(() => {
          this.updateTableSelection();
        });
      });
    },

    updateTableSelection() {
      for (let row of this.selectRows) {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.t-u-w {
  display: flex;
  justify-content: center;
}
.a-t {
  margin-bottom: 10px;
}
.oa-footer {
  position: absolute;
  bottom: 10px;
  right: 40px;
}
.content-wrap {
  position: relative;
  height: 65vh;
  overflow: scroll;
}
.cc-w {
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/component/OneAssignment.vue